module.exports = __webpack_public_path__ + "img/exhibits8.86b94991.png";